<template>

    <div class="col-sm-12 bg-lightest border-light cardHeight1 d-flex flex-column radius-normal">
        <div class="mb-4">
            <div class="text-center darker font-weight-600 mt-4 fs-large">
                {{title}}
            </div>
            <div class="dark text-center fs-small">
                {{subTitle}}
            </div>
        </div>
        <div class="text-center w-100 mb-5 mt-4">
            <div class="fs-superBig dark font-weight-400 mt-1">{{value1}}</div>
            <div class="fs-larger" :class="value2Class">{{value2}}</div>
        </div>
    </div>

</template>

<script>
    export default {
        data: function(){
            return {
                occupancyPercent:50
            }
        },
        props:[
            'title',
            'subTitle',
            'value1',
            'value2',
            'value2Class',
        ]
    }
</script>

<style scoped lang="scss">

    .cardHeight1{
        height: 230px;
    }

    .fs-superBig{
        font-size: 2.5rem;
    }
</style>



// WEBPACK FOOTER //
// cardSimple.vue?68099dee